import React from 'react';
import { Link } from 'react-router-dom';
import { Fragment } from 'react';
//import CookieConsent from "react-cookie-consent";
//import CookieBot from "react-cookiebot";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faFacebook,
  faInstagram,
  faTwitter,
} from '@fortawesome/free-brands-svg-icons';
const domainGroupId = '2a1e09f8-b957-46d3-9c7f-289e215dcb7e';

export class FooterBar extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <Fragment>
        <div className="site__footer clearfix">
          <div className="page__content">
            <div className="footer_content">
              <p>
                {/* ©2025 CONNECTICUT COMMUNITY FOR ADDICTION RECOVERY */}
                ©2025 Connecticut Community For Addiction Recovery (CCAR) All
                Rights Reserved.
              </p>
            </div>
            <div className="footer__nav">
              <ul>
                <li>
                  <Link to="/coach-contract">Coach Contract</Link>
                </li>
                <li>
                  <Link to="/privacy-policy">Privacy Policy</Link>
                </li>
                <li>
                  <Link to="/terms-and-conditions">Terms and Conditions</Link>
                </li>
              </ul>
              <ul>
                <li>
                  <a
                    href="https://www.facebook.com/people/Coacherly/61563970856811/"
                    target="_blank"
                  >
                    <FontAwesomeIcon icon={faFacebook} />
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.instagram.com/coacherly_ccar"
                    target="_blank"
                  >
                    <FontAwesomeIcon icon={faInstagram} />
                  </a>
                </li>
                <li>
                  <a href="https://x.com/CoacherlyOnline" target="_blank">
                    <FontAwesomeIcon icon={faTwitter} />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* <CookieBot domainGroupId={domainGroupId} /> */}
      </Fragment>
    );
  }
}

export default FooterBar;



// WEBPACK FOOTER //
// ./src/components/FooterBar/FooterBar.js